<script setup lang="ts">
</script>

<template>
  <div class="p-8">
    <div class="bg-red-500 text-white p-4 rounded-lg mb-4">
      <h1 class="text-2xl font-bold">Tailwind Test</h1>
      <p class="text-sm">If you can see this with red background, Tailwind is working!</p>
    </div>
    
    <div class="bg-blue-500 text-white p-4 rounded-lg mb-4">
      <h2 class="text-xl font-semibold">Custom Colors Test</h2>
      <div class="bg-primary text-white p-2 rounded mt-2">
        Primary Color: #1976D2
      </div>
    </div>
    
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="bg-slate-100 p-4 rounded-lg">
        <h3 class="font-medium text-slate-800">Card 1</h3>
        <p class="text-slate-600 text-sm">Testing responsive grid</p>
      </div>
      <div class="bg-slate-100 p-4 rounded-lg">
        <h3 class="font-medium text-slate-800">Card 2</h3>
        <p class="text-slate-600 text-sm">Testing responsive grid</p>
      </div>
      <div class="bg-slate-100 p-4 rounded-lg">
        <h3 class="font-medium text-slate-800">Card 3</h3>
        <p class="text-slate-600 text-sm">Testing responsive grid</p>
      </div>
    </div>
  </div>
</template>
